import CatalogPage from '@/components/feature/CatalogPage';
import { useDocumentMeta } from '@/hooks/useDocumentMeta';

export default function Movies() {
  useDocumentMeta(
    '星辰影院-最新电影分类浏览',
    '星辰影院电影分类页，收录动作、科幻、爱情、悬疑、喜剧等多种类型的最新电影，支持按年份、地区、类型筛选与最新、热门、评分排序。',
    '最新电影,电影分类,电影筛选,动作电影,科幻电影,热门电影,星辰影院',
  );

  return (
    <CatalogPage
      type="movie"
      title="电影分类"
      description="汇集动作、科幻、爱情、悬疑、动画等多种类型的电影作品。你可以通过左侧筛选栏按类型、年份、地区自由组合筛选，并选择最新、热门或评分排序，快速定位想看的影片。"
    />
  );
}